import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { FileAudio, Music, FileText, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface FilesTabContentProps {
  sessionFiles: any[];
}

const FilesTabContent: React.FC<FilesTabContentProps> = ({ sessionFiles }) => {
  return (
    <ScrollArea className="h-full">
      <div className="p-4 space-y-4">
        <div className="space-y-2">
          <h3 className="text-sm font-medium text-white flex items-center gap-2">
            <Music className="h-4 w-4 text-soundcharts-purple" />
            <span>Audio Files</span>
          </h3>
          
          {sessionFiles.filter(file => file.type === 'audio').length > 0 ? (
            <div className="space-y-2">
              {sessionFiles
                .filter(file => file.type === 'audio')
                .map((file, index) => (
                  <div 
                    key={index}
                    className="flex items-center justify-between p-2 rounded-md bg-black/30 border border-[#403E43]/40"
                  >
                    <div className="flex items-center gap-2">
                      <FileAudio className="h-4 w-4 text-soundcharts-purple" />
                      <span className="text-sm text-white truncate max-w-[180px]">
                        {file.name}
                      </span>
                    </div>
                    <Button variant="ghost" size="icon" className="h-8 w-8">
                      <Download className="h-4 w-4 text-white/70" />
                    </Button>
                  </div>
                ))}
            </div>
          ) : (
            <div className="text-sm text-white/60 p-2">
              No audio files available
            </div>
          )}
        </div>
        
        <div className="space-y-2">
          <h3 className="text-sm font-medium text-white flex items-center gap-2">
            <FileText className="h-4 w-4 text-soundcharts-purple" />
            <span>Documents</span>
          </h3>
          
          {sessionFiles.filter(file => file.type === 'document').length > 0 ? (
            <div className="space-y-2">
              {sessionFiles
                .filter(file => file.type === 'document')
                .map((file, index) => (
                  <div 
                    key={index}
                    className="flex items-center justify-between p-2 rounded-md bg-black/30 border border-[#403E43]/40"
                  >
                    <div className="flex items-center gap-2">
                      <FileText className="h-4 w-4 text-soundcharts-purple" />
                      <span className="text-sm text-white truncate max-w-[180px]">
                        {file.name}
                      </span>
                    </div>
                    <Button variant="ghost" size="icon" className="h-8 w-8">
                      <Download className="h-4 w-4 text-white/70" />
                    </Button>
                  </div>
                ))}
            </div>
          ) : (
            <div className="text-sm text-white/60 p-2">
              No documents available
            </div>
          )}
        </div>
        
        <div className="p-3 rounded-md bg-black/20 border border-[#403E43]/40">
          <p className="text-xs text-white/70">
            Drag and drop files here to share them with the session participants.
            Supported formats: MP3, WAV, PDF, TXT, DOC.
          </p>
        </div>
      </div>
    </ScrollArea>
  );
};

export default FilesTabContent;
